const API_URL = process.env.REACT_APP_BACKEND_URL;

export const fetchBlogPosts = async () => {
  try {
    const response = await fetch(`${API_URL}/api/blog/`);
    if (!response.ok) {
      throw new Error('Failed to fetch blog posts');
    }
    return await response.json();
  } catch (error) {
    console.error('Error fetching blog posts:', error);
    throw error;
  }
};

export const fetchBlogPostBySlug = async (slug) => {
  try {
    const response = await fetch(`${API_URL}/api/blog/${slug}`);
    if (!response.ok) {
      throw new Error(`Failed to fetch blog post: ${slug}`);
    }
    return await response.json();
  } catch (error) {
    console.error(`Error fetching blog post ${slug}:`, error);
    throw error;
  }
};

export const fetchCaseStudies = async () => {
  try {
    const response = await fetch(`${API_URL}/api/case-studies/`);
    if (!response.ok) {
      throw new Error('Failed to fetch case studies');
    }
    return await response.json();
  } catch (error) {
    console.error('Error fetching case studies:', error);
    throw error;
  }
};

export const fetchCaseStudyBySlug = async (slug) => {
  try {
    const response = await fetch(`${API_URL}/api/case-studies/${slug}`);
    if (!response.ok) {
      throw new Error(`Failed to fetch case study: ${slug}`);
    }
    return await response.json();
  } catch (error) {
    console.error(`Error fetching case study ${slug}:`, error);
    throw error;
  }
};
